// Lib
import { outboundClicksConfig } from '@/lib/analytics/kpis/pinterest/outboundClicks';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerOutboundClicksConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...outboundClicksConfig,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
